import { useNavigate } from "react-router-dom";
import { ProductVisual } from "./ProductVisual";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const ProductSlider = ({ categories }) => {
  const navigate = useNavigate();
  const products = categories.flatMap((c) => c.products);
  const loop = [...products, ...products];
  const duration = Math.max(60, products.length * 4.5);

  return (
    <section data-testid="product-slider" className="border-t border-[#221533]/10 bg-white py-12 sm:py-14 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-6 lg:px-12 mb-7 flex items-end justify-between gap-4">
        <p className="font-mono2 text-[11px] tracking-[0.35em] uppercase text-[#8E5A9E]">
          Our Products — {products.length} SKUs
        </p>
        <button
          data-testid="slider-view-all"
          onClick={() => navigate("/products")}
          className="font-manrope font-semibold text-sm text-[#74427F] hover:text-[#8E5A9E] transition-colors"
        >
          View all →
        </button>
      </div>
      <div className="relative">
        <div className="flex gap-4 sm:gap-5 w-max px-5 animate-slide hover:[animation-play-state:paused]" style={{ animationDuration: `${duration}s` }}>
          {loop.map((p, i) => (
            <button
              key={`${p.slug}-${i}`}
              data-testid={`slider-card-${i}`}
              onClick={() => navigate("/products")}
              className="w-44 sm:w-52 shrink-0 bg-[#FAF8FC] border border-[#221533]/10 rounded-xl overflow-hidden text-left hover:border-[#8E5A9E]/50 hover:shadow-[0_15px_35px_-15px_rgba(142,90,158,0.4)] transition-[border-color,box-shadow] duration-300 active:scale-[0.97]"
            >
              <div className="h-36 sm:h-40 spotlight flex items-center justify-center">
                {p.image_url ? (
                  <img src={`${BACKEND}${p.image_url}?w=400`} alt={p.name} loading="lazy" decoding="async" className="h-full w-full object-contain p-3" />
                ) : (
                  <ProductVisual type={p.visual} className="h-[78%] w-auto opacity-90" />
                )}
              </div>
              <div className="p-3.5 sm:p-4 border-t border-[#221533]/10">
                <p className="font-clash text-base font-medium text-[#221533] truncate">{p.name}</p>
                <p className="font-mono2 text-[10px] tracking-[0.15em] uppercase text-[#221533]/45 mt-1 truncate">{p.pack_size}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
